export function sanitizeInternalPath(value: unknown): string | undefined {
  if (typeof value !== 'string' || value.length === 0) return undefined;
  if (!value.startsWith('/') || value.startsWith('//')) return undefined;
  if (value.includes('\\')) return undefined;
  if ([...value].some((char) => char.charCodeAt(0) < 0x20)) return undefined;
  return value;
}
